import { t } from '@lingui/core/macro'

export const TableReviewOverlap = () => (
  <div
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 300,
      pointerEvents: 'auto',
      padding: 50,
    }}
  >
    <span
      style={{
        fontSize: 14,
        fontStyle: 'italic',
        color: '#333',
        textAlign: 'center',
      }}
    >
      {t`This pick list is locked while pending suggestions are under review. Once all suggestions are resolved, new comments and suggestions can be added.`}
    </span>
  </div>
)
